import { Button, Card, Col, Form, Icon, InputNumber, notification, Row, Select, PageHeader } from 'antd'
import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import {
    fetchResource as getAssetDetails,
} from "../../../appRedux/actions/Asset";
import {
    createCalibrationList,
    createFilteration,
    getCalibrationList,
    deleteCalibrationList
} from "../../../appRedux/actions/AssetFuelSensorCalibration";

import CalibrationList from './CalibrationList'
import FuelSensorData from './FuelSensorData';
import FuelTankProfileChart from './FuelTankProfileChart'
import AccessControl from '../../../components/AccessControl';

const mapStateToProps = ({ commonData, auth, asset, assetFuelSensorCalibration }) => {
    return {
        // will be available as props.trips
        loading: commonData.loading,
        authUser: auth.authUser,
        asset: asset.edit,
        calibrationData: assetFuelSensorCalibration.calibrationData
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAssetDetails,
        createCalibrationList,
        createFilteration,
        getCalibrationList,
        deleteCalibrationList
    }
}

function SensorSlab(props) {
    const [quantity, setQuantity] = useState(0);
    const [voltage, setVoltage] = useState(0);
    const [items, setItems] = useState([]);

    const [deviceIMEI, setDeviceIMEI] = useState(null)
    const [fuelSensorId, setFuelSensorId] = useState(null)

    const [asset, setAsset] = useState(null)
    const [attachedIotDevice, setAttachedIotDevice] = useState(null)
    const [attachedFuelSensorInIotDevice, setAttachedFuelSensorInIotDevice] = useState(null)
    const [topic, setTopic] = useState(null)
    const [dataField, setDataField] = useState(9)
    const [isSensorListening, setIsSensorListening] = useState(false)

    const [fuelLevelIdentifierName, setFuelLevelIdentifierName] = useState('fuel_level_analog')
    const [filterationLevel, setFilterationLevel] = useState(15)
    const [refuelingThreshold, setRefuelingThreshold] = useState(1.5)
    const [drainingThreshold, setDrainingThreshold] = useState(1.5)
    const [axisVarianceThreshold, setAxisVarianceThreshold] = useState(1000)
    const [refuelShortageTolerance, setRefuelShortageTolerance] = useState(1)
    const [authUser, setAuthUser] = useState(null)

    useEffect(() => {
        setAuthUser(props.authUser)
    }, [props.authUser])

    useEffect(() => {
        const id = props.match.params.id;
        const aid = props.match.params.asset;
        const fsd = props.match.params.fsd;
        // console.log(id, aid);
        if (id)
            setDeviceIMEI(id)
        if (fsd)
            setFuelSensorId(fsd)
        if (aid) {
            // setAsset(aid)
            props.getAssetDetails(aid)
        }
    }, []);

    useEffect(() => {
        const data = props.calibrationData || {}
        // console.log(data);
        setItems(data && data.list || [])
        if (data && data.fuelLevelIdentifierName)
            setFuelLevelIdentifierName(data.fuelLevelIdentifierName)
        if (data && data.filterationLevel)
            setFilterationLevel(data.filterationLevel)
        if (data && data.refuelingThreshold)
            setRefuelingThreshold(data.refuelingThreshold)
        if (data && data.drainingThreshold)
            setDrainingThreshold(data.drainingThreshold)
        if (data && data.axisVarianceThreshold)
            setAxisVarianceThreshold(data.axisVarianceThreshold)
        if (data && data.refuelShortageTolerance)
            setRefuelShortageTolerance(data.refuelShortageTolerance)
    }, [props.calibrationData])

    useEffect(() => {
        if (props.asset && deviceIMEI) {
            const asset = props.asset;

            const attachedDevice = (asset.dependents || []).filter(d => d && d.assetModel && d.assetModel.isTagDevice && d.tagDeviceId === deviceIMEI)
            if (attachedDevice && attachedDevice.length) {
                setAttachedIotDevice(attachedDevice[0])
                const fuelSensor = (attachedDevice[0].dependents || []).filter(dd => dd && dd.assetModel && dd.assetModel.isFuelSensorDevice)
                if (fuelSensor && fuelSensor.length && fuelSensorId && fuelSensorId === fuelSensor[0]._id)
                    setAttachedFuelSensorInIotDevice(fuelSensor[0])
            }
            setAsset(props.asset)
        }
    }, [props.asset, deviceIMEI])

    useEffect(() => {
        if (attachedIotDevice && attachedFuelSensorInIotDevice && asset) {
            // console.log(attachedIotDevice, attachedFuelSensorInIotDevice, asset)
            setTopic(`${attachedIotDevice.tagDeviceId}/data`)
            props.getCalibrationList(asset._id, attachedFuelSensorInIotDevice._id)
        }
    }, [attachedFuelSensorInIotDevice, attachedIotDevice, asset])

    const handleAdd = () => {
        const existingVoltage = items.filter(i => i.voltage === voltage || i.quantity === quantity)
        if (existingVoltage && existingVoltage.length) {
            openNotificationWithIcon('error', 'Same quantity/voltage reading already exist in the list!')
        } else
            setItems([...items, { quantity, voltage }]);
    };

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message,
        });
    };

    const handleVoltageChange = (newVoltage) => {
        setVoltage(newVoltage);
    };


    const toggleReciveSensorData = (isListening = undefined) => {
        if (isListening && isListening === 'N')
            setIsSensorListening(false)
        else
            setIsSensorListening(!isSensorListening)
    }

    const delteFromList = (quantity, voltage, currentItems) => {
        // console.log(quantity, voltage)
        // console.log(it)
        setItems(currentItems.filter(obj => obj.quantity !== quantity && obj.voltage !== voltage));
    }

    const handleSaveList = () => {
        // console.log(items, attachedFuelSensorInIotDevice)
        if (items && items.length && attachedFuelSensorInIotDevice && asset) {
            props.createCalibrationList(asset._id, attachedFuelSensorInIotDevice._id, items)
        }
    }

    const handleDeleteList = () => {
        // console.log(items, attachedFuelSensorInIotDevice)
        if (items && items.length && attachedFuelSensorInIotDevice && asset) {
            props.deleteCalibrationList(asset._id, attachedFuelSensorInIotDevice._id)
        }
    }

    const handleFilteration = () => {
        if (filterationLevel && refuelingThreshold && drainingThreshold && axisVarianceThreshold && asset && fuelLevelIdentifierName) {
            console.log(filterationLevel, refuelingThreshold, drainingThreshold, axisVarianceThreshold, refuelShortageTolerance, fuelLevelIdentifierName)
            props.createFilteration(asset._id, attachedFuelSensorInIotDevice._id, { filterationLevel, refuelingThreshold, drainingThreshold, axisVarianceThreshold, refuelShortageTolerance, fuelLevelIdentifierName })
        }
    }

    useEffect(() => {
        if (!isSensorListening) {
            setVoltage(0)
            setQuantity(0)
        }
    }, [isSensorListening])
    // console.log(attachedIotDevice, attachedFuelSensorInIotDevice);

    return (
        <div>
            <PageHeader
                ghost={false}
                style={{
                    border: '1px solid #1890FF',
                    backgroundColor: '#1890FF',
                    borderRadius: '5px',
                    marginBottom: '10px',
                    color: 'white',
                }}
                subTitle={
                    <div style={{ color: 'white' }}>
                        <div>Fuel Calibration and Settings for {asset && asset.assetCode}/{asset && asset.ownerCode} ({asset && asset.altName})</div>
                        <div> IOT Device: {attachedIotDevice && attachedIotDevice.assetCode} ({attachedIotDevice && attachedIotDevice.tagDeviceId})</div>
                        <div>Fuel Sensor: {attachedFuelSensorInIotDevice && attachedFuelSensorInIotDevice.assetCode} ({attachedFuelSensorInIotDevice && attachedFuelSensorInIotDevice.altName})</div>
                    </div>
                } />
            {topic &&
                <FuelSensorData onVoltageChange={handleVoltageChange} topic={topic} dataField={dataField}
                    isSensorListening={isSensorListening} toggleReciveSensorData={toggleReciveSensorData} />
            }
            <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card className={`gx-card-metrics`}
                        title={
                            <div>
                                <div>Fuel Calibration Form</div>
                            </div>
                        }
                        extra={
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>
                                    <AccessControl resource={'AssetFuelSensorCalibration'} permissionNeeded={'c'}
                                        roles={authUser ? authUser.roles : []} render={(props) => {
                                            return <Button
                                                size="small"
                                                style={{ marginTop: '10px' }}
                                                type={isSensorListening ? 'danger' : 'primary'}
                                                onClick={toggleReciveSensorData}
                                            >
                                                {isSensorListening ? 'Stop Listening' : 'Start Listening'}
                                            </Button>
                                        }} />
                                    <Icon type="sync" spin={isSensorListening ? true : false} style={{ color: `${isSensorListening ? '#eb2f96' : '#52c41a'}`, marginTop: '0px' }} />
                                </div>
                                <div>
                                    <span style={{ marginRight: '8px' }}>Data Field:</span>
                                    <InputNumber value={dataField} onChange={setDataField} disabled={isSensorListening} size='small' style={{ marginRight: '8px', marginBottom: '0px' }} />
                                </div>
                            </div>
                        }>
                        <Form layout="inline">
                            <Form.Item label="Quantity(Ltr.)">
                                <InputNumber value={quantity} onChange={setQuantity} />
                            </Form.Item>

                            <Form.Item label="Voltage/Height">
                                <InputNumber value={voltage} readOnly disabled style={{
                                    color: 'red', // Text color
                                    backgroundColor: '#f5f5f5' // Off-white background
                                }} />
                            </Form.Item>

                            <Form.Item label="Custom Voltage/Height">
                                <AccessControl resource={'AssetFuelSensorCalibration'} permissionNeeded={'c'}
                                    roles={authUser ? authUser.roles : []} render={(props) => {
                                        return <InputNumber readOnly={isSensorListening} style={{
                                            color: 'green', // Text color
                                        }} onChange={(value) => setVoltage(Number(value) || 0)} />
                                    }} />
                            </Form.Item>

                            <Form.Item>
                                <AccessControl resource={'AssetFuelSensorCalibration'} permissionNeeded={'c'}
                                    roles={authUser ? authUser.roles : []} render={(props) => {
                                        return <Button className='gx-btn-cyan' size='small' icon='plus' style={{ marginTop: '48px' }}
                                            // disabled={!attachedFuelSensorInIotDevice || !isSensorListening} 
                                            onClick={handleAdd}>
                                            Add to List
                                        </Button>
                                    }} />

                            </Form.Item>

                        </Form>
                    </Card>
                    <Card className={`gx-card-metrics`}>
                        <Form>
                            <Form.Item label="Fuel level identifier Name">
                                <Select value={fuelLevelIdentifierName} onChange={setFuelLevelIdentifierName}>
                                    <Select.Option value="fuel_level_analog">Fuel Level Analog</Select.Option>
                                    <Select.Option value="ble_fuel_level_1">BLE Fuel Level 1</Select.Option>
                                    <Select.Option value="ble_fuel_level_2">BLE Fuel Level 2</Select.Option>
                                    <Select.Option value="ble_fuel_level_3">BLE Fuel Level 3</Select.Option>
                                    <Select.Option value="ble_fuel_level_4">BLE Fuel Level 4</Select.Option>
                                    <Select.Option value="ul_fuel_level_analog">Ultrasonic Analog Fuel Level</Select.Option>
                                </Select>
                            </Form.Item>

                            <Form.Item label="Filteration level">
                                <InputNumber value={filterationLevel} onChange={setFilterationLevel} />
                            </Form.Item>

                            <Form.Item label="Refueling Threhold Value">
                                <InputNumber value={refuelingThreshold} onChange={setRefuelingThreshold} />
                            </Form.Item>

                            <Form.Item label="Draining Threshold Value">
                                <InputNumber value={drainingThreshold} onChange={setDrainingThreshold} />
                            </Form.Item>

                            <Form.Item label="Axis Variance Threshold">
                                <InputNumber value={axisVarianceThreshold} onChange={setAxisVarianceThreshold} />
                            </Form.Item>

                            <Form.Item label="Refuel Shortage Tolerance %">
                                <InputNumber value={refuelShortageTolerance} onChange={setRefuelShortageTolerance} />
                            </Form.Item>

                            <Form.Item>
                                <AccessControl resource={'AssetFuelSensorCalibration'} permissionNeeded={'u'}
                                    roles={authUser ? authUser.roles : []} render={(props) => {
                                        return <Button className='gx-btn-primary' size='default' icon='filter' style={{ marginTop: '48px' }} onClick={handleFilteration}>
                                            Save Filteration
                                        </Button>
                                    }} />

                            </Form.Item>

                        </Form>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card className={`gx-card-metrics`} title={`Calibration Slab for Asset ${asset && asset.assetCode} (${asset && asset.altName})`}>

                        <CalibrationList data={items} delteFromList={delteFromList} authUser={authUser} />
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>

                            <AccessControl resource={'AssetFuelSensorCalibration'} permissionNeeded={'c'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return <Button type="primary" disabled={!items || !items.length} onClick={handleSaveList}>
                                        Save Calibration List
                                    </Button>
                                }} />

                            <AccessControl resource={'AssetFuelSensorCalibration'} permissionNeeded={'d'}
                                roles={authUser ? authUser.roles : []} render={(props) => {
                                    return <Button type="danger" disabled={!items || !items.length} onClick={handleDeleteList} style={{ marginLeft: '10px' }}>
                                        Delete Calibration List
                                    </Button>
                                }} />

                        </div>
                        <FuelTankProfileChart data={(items || []).filter(i => i.quantity > 0)} />
                    </Card>
                </Col>

            </Row>
        </div>
    )
}


export default connect(mapStateToProps, mapDispatchToProps())(SensorSlab);